/*global google*/
/* eslint-disable */

import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from 'react-google-maps'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Redirect} from 'react-router-dom'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

const {compose, withProps} = require('recompose')

class EditCity extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      provinceId: '',
      cityName: '',
      provinceName: '',
      latitude: '',
      longitude: '',
      provinces: [],
      redirect: false
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    this.setState({
      provinceValue: selectedOption.value
    })
    console.log(`Option selected:`, selectedOption)
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/Cities" />
    }
  }
  componentDidMount() {
    let {cityId} = this.props.match.params
    http
      .get(`public/base/type/get/city?cityId=${cityId}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error === null) {
          let result = response.data.object
          this.setState({
            provinceId: result.provinceId,
            cityName: result.cityName,
            latitude: result.latitude,
            longitude: result.longitude
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${BASE_REPORT.BASE_REPORT_PROVINCE}?export=${1}`, {})
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            provinces: response.data.object.result
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  addCity() {
    let {cityId} = this.props.match.params

    var name = document.getElementById('name').value
    var province = document.getElementById('province').value
    var errorForm = false
    var nameError = false
    var provinceError = false
    var positionError = false
    if (name === '') {
      errorForm = true
      nameError = true
      message.error('نام شهر را وارد کنید')
    } else {
      if (!nameError) {
        this.setState({
          error: 'none'
        })
      }
    }
    if (this.state.latitude === 0 && this.state.longitude === 0) {
      errorForm = true
      positionError = true
      message.error('موقعیت شهر را از روی نقشه تعیین کنید')
    } else {
      if (!positionError) {
        this.setState({error: ''})
      }
    }
    if (province === '') {
      errorForm = true
      provinceError = true
      message.error('استان را وارد کنید')
    } else {
      if (!province) {
        this.setState({
          error: ''
        })
      }
    }
    if (!errorForm) {
      const token = sessionStorage.getItem('accessToken')
      var data = {
        name: name,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        provinceId: province,
        cityId: cityId
      }
      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_EDIT_CITY}`, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            message.success('شهر ویرایش شد')
            setInterval(() => {
              window.location.assign('/Cities')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  render() {
    const MapWithADrawingManager = compose(
      withProps({
        googleMapURL:
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyAZt97TFAMPbJkQreQAb9KyRx3Qu7dOcxw&v=3.exp&libraries=geometry,drawing,places',
        loadingElement: <div style={{height: `100%`}} />,
        containerElement: <div style={{height: `300px`}} />,
        mapElement: <div style={{height: `100%`}} />
      }),
      withScriptjs,
      withGoogleMap
    )(() => (
      <GoogleMap
        defaultCenter={new google.maps.LatLng(this.state.latitude, this.state.longitude)}
        defaultZoom={6}
        ref={(node) => (this.myMap = node)}
        onClick={(e) => {
          this.setState({
            latitude: e.latLng.lat(),
            longitude: e.latLng.lng()
          })
        }}
      >
        <Marker
          defaultPosition={{lat: this.state.latitude, lng: this.state.longitude}}
          ref={(node) => (this.marker = node)}
        />
      </GoogleMap>
    ))

    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <MDBBreadcrumb>
            <MDBBreadcrumbItem>بروزرسان</MDBBreadcrumbItem>
            <MDBBreadcrumbItem>لیست شهر ها</MDBBreadcrumbItem>
            <MDBBreadcrumbItem active>ویرایش شهر</MDBBreadcrumbItem>
          </MDBBreadcrumb>
          <MapWithADrawingManager />
          <form className="inlineForm" onSubmit={this.submitForm.bind(this)}>
            <figure>
              <label>نام شهر : (الزامی)</label>
              <input type="text" defaultValue={this.state.cityName} className="form-control" id="name" name="name" />
            </figure>
            <figure>
              <label>استان را انتخاب کنید (الزامی)</label>
              <select className="form-control" id="province" name="province">
                {this.state.provinces.map((pro, index) => (
                  <option value={pro.provinceId} selected={pro.provinceId === this.state.provinceId ? true : false}>
                    {pro.name}
                  </option>
                ))}
              </select>
            </figure>
            <figure>
              <label className="hiddenLabel">نام شهر : (الزامی)</label>
              <button className="btn btn-primary form-control btn-sm" onClick={this.addCity.bind(this)}>
                ویرایش شهر
              </button>
              {this.renderRedirect()}
            </figure>
          </form>
        </div>
      </div>
    )
  }
}

export default EditCity
